<template>
    <!-- List réponses -->
    <div id="row-reponse" v-if="list_reponses.length">
        <form
            v-for="reponse in list_reponses"
            :key="reponse.id_reponse"
            :id="'form-reponse-' + reponse.id_reponse"
            :class="[
                'form-reponse', 
                'form-notification-' + reponse.id_reponse, 
                reponse.parametres?.class ?? ''
            ]"
            @submit.prevent=""
        >
            <!-- CSRF token field (injected dynamically) -->
            <input type="hidden" :value='this.csrfTokenValue' :name="this.csrfTokenName">
            <input
                id="input-id-parent"
                type="hidden"
                name="id_parent"
                :value="reponse.id_reponse"
            />
    
            <!-- Bouton réponses par défaut -->
            <button
                :id="'button-' + reponse.id_reponse"
                :key="reponse.id_reponse"
                class="reponse w-100"
                type="button"
                @click="click_reponse(reponse, $event)"
                v-html="reponse.texte"
            >
            </button>
        </form>
    </div>
</template>
  
<script>
    export default {
        name: 'ReponseComponent',
        props: {
            list_reponses: {
                type: Array,
                default: () => [],
            },
            csrfTokenName: {
                type: String,
                required: true
            },
            csrfTokenValue: {
                type: String,
                required: true
            }
        },
        data() {
            return {};
        },
        mounted() {
        },
        methods: {
            // On click on a reponse, check animation then submit it
            click_reponse( reponse, event ) {
                let methode_animation = null;
                // check if reponse has an animation on click
                if ( reponse.parametres?.animation?.load === 'click' ) {
                    // get animation function name
                    methode_animation = reponse.parametres.animation.fonction;
                    // Do animation then submit the reponse
                    window[ methode_animation ]( reponse.id_reponse )
                    .then(() => {
                        this.submit_reponse( reponse.id_reponse, event );
                    });
                } else {
                    this.submit_reponse( reponse.id_reponse, event );
                }
            },
            // Envoi de la reponse utilisateur
            submit_reponse( id_reponse, event ) {
                // send reponse using vanilla js function
                window.ajax_traitement_list_action( id_reponse, 'reponse', false, event );
            },
        },
    };
</script>
